"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_219)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_219`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#2B5DEA"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 4H30V20H-6V4Z",
					fill: "#FFDF29"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 6H30V18H-6V6Z",
					fill: "#D70000"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 6.85602V17.144C16.572 17.144 18.856 13.716 20.572 12C18.856 10.284 16.572 6.85602 12 6.85602Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 6.85602C7.99998 6.85602 5.14398 10.284 3.42798 12C5.14398 13.716 7.99998 17.144 12 17.144V6.85602Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.85199 10.172H8.69199V13.824H7.85199V10.172ZM9.92799 10.172H10.768V13.824H9.92799V10.172Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M13.112 10.172H13.952V13.824H13.112V10.172ZM15.188 10.172H16.028V13.824H15.188V10.172Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_219`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SZFlag };
